var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/store/tenantFeatures/index.ts
var tenantFeatures_exports = {};
__export(tenantFeatures_exports, {
  FEATURES: () => FEATURES,
  entityAdapter: () => entityAdapter,
  initialState: () => initialState
});

// src/store/tenantFeatures/typings.ts
var FEATURES = /* @__PURE__ */ ((FEATURES2) => {
  FEATURES2[FEATURES2["Estimates"] = 4] = "Estimates";
  FEATURES2[FEATURES2["CampaignTracking"] = 7] = "CampaignTracking";
  FEATURES2[FEATURES2["CtmWebform"] = 11] = "CtmWebform";
  FEATURES2[FEATURES2["ServiceBot"] = 15] = "ServiceBot";
  FEATURES2[FEATURES2["TidalTheme"] = 17] = "TidalTheme";
  FEATURES2[FEATURES2["Localization"] = 25] = "Localization";
  FEATURES2[FEATURES2["NavigationAndFilterImprovements"] = 29] = "NavigationAndFilterImprovements";
  FEATURES2[FEATURES2["FormPackets"] = 30] = "FormPackets";
  FEATURES2[FEATURES2["AgreementAttachments"] = 32] = "AgreementAttachments";
  FEATURES2[FEATURES2["WWMSSO"] = 34] = "WWMSSO";
  FEATURES2[FEATURES2["MeasureAI"] = 35] = "MeasureAI";
  FEATURES2[FEATURES2["MapView"] = 36] = "MapView";
  FEATURES2[FEATURES2["MappedUserSSO"] = 38] = "MappedUserSSO";
  FEATURES2[FEATURES2["D2DKnockStatus"] = 39] = "D2DKnockStatus";
  FEATURES2[FEATURES2["MapViewAddLead"] = 40] = "MapViewAddLead";
  FEATURES2[FEATURES2["PestPacPins"] = 41] = "PestPacPins";
  FEATURES2[FEATURES2["VoiceToText"] = 45] = "VoiceToText";
  FEATURES2[FEATURES2["UnifiedCalendar"] = 44] = "UnifiedCalendar";
  FEATURES2[FEATURES2["UDFMappings"] = 47] = "UDFMappings";
  FEATURES2[FEATURES2["AutoReviewPendingLeads"] = 48] = "AutoReviewPendingLeads";
  FEATURES2[FEATURES2["SalesPersonFilter"] = 49] = "SalesPersonFilter";
  FEATURES2[FEATURES2["ServiceCodes"] = 50] = "ServiceCodes";
  FEATURES2[FEATURES2["D2DTerritories"] = 51] = "D2DTerritories";
  return FEATURES2;
})(FEATURES || {});

// src/store/tenantFeatures/entityAdapter.ts
import { createEntityAdapter } from "@reduxjs/toolkit";
var entityAdapter = createEntityAdapter({
  selectId: (tf) => tf.featureId,
  sortComparer: (a, b) => a.featureName.localeCompare(b.featureName)
});
var initialState = entityAdapter.getInitialState({
  schedulingEligibility: false
});

export {
  FEATURES,
  entityAdapter,
  initialState,
  tenantFeatures_exports
};
//# sourceMappingURL=chunk-VJF6V4RE.js.map